import { DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { LineGraphComponent, SeComponentsModule } from '@se/components';
import { SePlatformModule, SeSharedModule } from '@se/platform';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SeUiAnatomicMapModule } from '@se/ui.anatomic.map';

import { CpAdditionalContentComponent } from './cp-controls/additional-content/additional-content.component';
import { CpAutocompleteComponent } from './cp-controls/autocomplete/autocomplete.component';
import { CpComboComponent } from './cp-controls/combo/combo.component';
import { CpDatetimeComponent } from './cp-controls/datetime/datetime.component';
import { CpGenericComponent } from './cp-controls/generic/generic.component';
import { CpGridComponent } from './cp-controls/grid/grid.component';
import { CpImportComponent } from './cp-controls/import/import.component';
import { CpImportGridComponent } from './cp-controls/import/import-grid/import-grid.component';
import { CpInputComponent } from './cp-controls/input/input.component';
import { CpPlaceholderComponent } from './cp-controls/placeholder/placeholder.component';
import { CpRadioComponent } from './cp-controls/radio/radio.component';
import { CpSelectorComponent } from './cp-controls/selector/selector.component';
import { CpTextEditorComponent } from './cp-controls/text-editor/text-editor.component';
import { CpUserControlComponent } from './cp-controls/user-control/user-control.component';

import { CpEffects } from './store/cp.effects';
import { cpReducer } from './store/cp.reducer';
import { cpFeatureKey } from './store/cp.state';

import { CpMapWrapperComponent } from './cp-controls/map-wrapper/map-wrapper.component';
import { CpNumericComponent } from './cp-controls/numeric/numeric.component';
import { CpMeasureComponent } from './cp-controls/measure/measure.component';
import { CpMultiStageMapWrapperComponent } from './cp-controls/multistage-map-wrapper/multistage-map-wrapper.component';
import { CpGraphComponent } from './cp-controls/graph/graph.component';
import { CustomPageControlGridComponent } from './cp-ui-engine/custom-page-control-grid/custom-page-control-grid.component';
import { CustomPageControlGridModalComponent } from './cp-ui-engine/custom-page-control-grid-modal/custom-page-control-grid-modal.component';
import { CpImagingEffects } from './store/cp.effects.imaging';
import { CpGridDefaultGroupsComponent } from './cp-controls/grid-default-groups/grid-default-groups.component';
import { controlServiceCheckToken } from './control-check';
import { CpControlsService } from './cp-controls.service';

@NgModule({
    imports: [
        DragDropModule,
        SeSharedModule,
        SePlatformModule,
        SeComponentsModule,
        SeUiAnatomicMapModule,
        TranslateModule,
        StoreModule.forFeature(cpFeatureKey, cpReducer),
        EffectsModule.forFeature([CpEffects, CpImagingEffects]),
        // TODO: da spostare in graph.component una volta che sarà standalone
        LineGraphComponent,
    ],
    providers: [DatePipe, DecimalPipe, { provide: controlServiceCheckToken, useExisting: CpControlsService }],
    declarations: [
        CpAdditionalContentComponent,
        CpAutocompleteComponent,
        CpComboComponent,
        CpDatetimeComponent,
        CpGenericComponent,
        CpGraphComponent,
        CpGridComponent,
        CpImportComponent,
        CpImportGridComponent,
        CpInputComponent,
        CpMapWrapperComponent,
        CpMeasureComponent,
        CpMultiStageMapWrapperComponent,
        CpNumericComponent,
        CpPlaceholderComponent,
        CpRadioComponent,
        CpSelectorComponent,
        CpTextEditorComponent,
        CpUserControlComponent,
        CustomPageControlGridComponent,
        CustomPageControlGridModalComponent,
        CpGridDefaultGroupsComponent,
    ],
    exports: [
        CpAdditionalContentComponent,
        CpAutocompleteComponent,
        CpComboComponent,
        CpDatetimeComponent,
        CpGenericComponent,
        CpGraphComponent,
        CpGridComponent,
        CpImportComponent,
        CpImportGridComponent,
        CpInputComponent,
        CpMapWrapperComponent,
        CpMeasureComponent,
        CpMultiStageMapWrapperComponent,
        CpNumericComponent,
        CpPlaceholderComponent,
        CpRadioComponent,
        CpSelectorComponent,
        CpTextEditorComponent,
        CpUserControlComponent,
        CustomPageControlGridComponent,
        CustomPageControlGridModalComponent,
        DragDropModule,
        CpGridDefaultGroupsComponent,
    ],
})
export class SeCpEngineModule {}
